import {
  SelectField as BaseSelectField,
  type SelectFieldProps,
} from '@shared/ui-components/form-fields/select-field';

import { useGlobalCmsContentContext } from '../providers/global-cms-context';

export const SelectField = (props: SelectFieldProps) => {
  const { cmsContent } = useGlobalCmsContentContext();

  return (
    <BaseSelectField
      {...props}
      hasOptionalLabel={props.hasOptionalLabel}
      noOptionsLabel={cmsContent.noOptionsLabel}
      optionalLabel={cmsContent.optionalLabel}
    />
  );
};
